<!-- #72 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        OMS Category Screen
      </div>
      <v-spacer></v-spacer>
      <v-btn
        @click="syncScrren()"
        color="primary"
        :loading="syncButton"
        small
        v-if="
          checkPermission('app_ecom_vendors:fulfillment_sku_category_sync') &&
          userCategory.user_category === 3
        "
        >Sync</v-btn
      >
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="headers"
      :items="omsList"
      :options.sync="options"
      :server-items-length="total"
      :loading="omsListLoader"
      class="elevation-1 custom-icon-size"
      hide-default-footer
      disable-pagination
    >
    </v-data-table>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},
  computed: {
    ...mapGetters(["userCategory"]),
  },
  data: () => ({
    headers: [
      {
        text: "Category Name",
        value: "category_name",
        class: "body-1 font-weight-bold",
        align: "left",
      },
      {
        text: "Category Code",
        value: "category_code",
        class: "body-1 font-weight-bold",
        align: "left",
      },
    ],
    options: {},
    total: 0,
    omsList: [],
    omsListLoader: false,
    syncButton: false,
  }),

  watch: {
    options: {
      handler() {
        this.fetchomsCategoryList();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["getomsCategoryList", "syncOmsScreen"]),
    fetchomsCategoryList() {
      this.omsList = [];
      this.omsListLoader = true;
      this.getomsCategoryList({
        ...this.options,
        ...this.filtersArr,
        type: this.$route.params.type,
      })
        .then((res) => {
          this.omsListLoader = false;
          this.omsList = res.data;
          this.total = res.data.total;
        })
        .catch(() => {
          this.omsListLoader = false;
        });
    },
    syncScrren() {
      this.syncButton = true;
      this.syncOmsScreen().then(() => {
        this.syncButton = false;
        this.fetchomsCategoryList();
      });
    },
  },
};
</script>
